import { useEffect, useState } from "react";
import { useFieldArray } from "react-hook-form";
import { Plus, Trash2 } from "lucide-react";
import { formatCurrency } from "../../util";
import { useSelector } from "react-redux";

const ReformulationInputTable = ({
  control,
  register,
  errors,
  watch,
  name,
  label,
  setValue,
  donor_id,
}) => {
  const reformulationItems = useSelector(
    (state) => state.config.reformulationItems
  );
  const { fields, append, remove } = useFieldArray({
    control,
    name: name,
  });
  const items = watch(name) || [];
  const [data, setData] = useState(reformulationItems);

  useEffect(() => {
    watch(fields.map((_, index) => `${name}.[${index}].name`));
    watch(fields.map((_, index) => `${name}.[${index}].rename`));
  }, [name, fields, items, watch]);

  // Handle quantity and amount changes
  useEffect(() => {
    fields.forEach((_, index) => {
      setValue(`${name}[${index}].number`, index + 1);
    });
  }, [items, fields, name]);

  return (
    <div className="mb-10 w-full overflow-x-hidden flex-1">
      <div className="flex items-center justify-between">
        <label className="mb-2 text-text-1/90 font-medium">{label}</label>
        <button
          type="button"
          onClick={
            () =>
              append({
                id: null,
                donor_id: donor_id,
                name: "",
                rename: "",
              }) // Add new empty item
          }
          className="bg-primary text-white p-1 rounded"
        >
          <Plus size={15} className="text-text-gen" />
        </button>
      </div>
      {/* Table Communication */}
      {items && (
        <div className="table-container !w-full overflow-x-auto">
          <table className="text-nowrap">
            <thead>
              <tr className="bg-bkg">
                <td className="p-1 py-2 bg-gray-600 text-text-gen ">No</td>
                <td className="p-1 py-2 bg-gray-600 text-text-gen ">Name</td>

                <td className="p-1 py-2 bg-gray-600 text-text-gen text-center ">
                  Rename
                </td>
                <td className="p-1 py-2 bg-gray-600 text-text-gen ">Action</td>
              </tr>
            </thead>
            <tbody>
              {fields.map((field, index) => (
                <tr key={index}>
                  <td className="p-1">{index + 1}</td>
                  <td className="p-1">
                    <div className="invisible">
                      <input
                        type="hidden"
                        defaultValue={field.value}
                        {...register(`${name}.[${index}].id`)}
                      />
                      <input
                        type="hidden"
                        defaultValue={index + 1}
                        {...register(`${name}.[${index}].number`)}
                      />
                      <input
                        type="hidden"
                        defaultValue={field.value}
                        {...register(`${name}.[${index}].donor_id`)}
                      />
                    </div>
                    <select
                      className=" bg-content px-2 py-1 border-2 border-bkg2 rounded-none text-base focus:border-bkg text-text-1/75 outline-none"
                      defaultValue={field.value}
                      {...register(`${name}.[${index}].name`)}
                    >
                      <option value=""> -- Select Item </option>
                      {data.map((item) => (
                        <option value={item.value}>{item.name}</option>
                      ))}
                    </select>
                  </td>
                  <td className="p-1 text-center">
                    <input
                      type="text"
                      defaultValue={field.value}
                      className="focus:outline-primary p-0.5 mx-1 bg-content hover:bg-text-bkg2 w-40 px-2"
                      {...register(`${name}.[${index}].rename`)}
                    />
                  </td>

                  <td className="p-1  text-right">
                    <button
                      type="button"
                      onClick={() => remove(index)}
                      className="text-red-500 px-2 py-1 rounded "
                    >
                      <Trash2 size={15} />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          {/* Error */}
          {errors && (
            <p className="text-red-400 text-xs text-wrap ">{errors.message}</p>
          )}
        </div>
      )}
    </div>
  );
};

export default ReformulationInputTable;
